import React, { useState } from 'react';
import { useUser } from '../utils/UserContext';
import TabBar from '../components/shared/TabBar';
import InnerTabsd from '../components/shared/InnerTabsd';
import { EditIcon, PlusIcon, CalendarIcon2, LockIcon } from '../components/shared/Icons';
import ChangePassword from './ChangePassword';
import FilterClientTickets from './FilterClientTickets';
import DepartureTicketForm from './DepartureTicketForm';
import CalendarIframe from './CalendarIframe';









const TABS = [
  {
    id: 'workflow',
    label: 'Add',
    
  },
  {
    id: 'update',
    label: 'Updates',
    
  },
  {
    id: 'calendar',
    label: 'Calendar',
    
  },
  {
    id: 'clientaccount',
    label: 'Accounts',
    
  },
  
  
];

const WORKFLOW_INNER = [
  { id: 'clientsticket', label: 'New Ticket', icon: <PlusIcon />, component: DepartureTicketForm },
  
  
];


const UPDATE_INNER = [
   { id: 'ticketupdates', label: 'Update Tickets', icon: <EditIcon />, component: FilterClientTickets },
];



const CALENDAR_INNER = [
  { id: 'ticketcalendar', label: 'Tickets', icon: <CalendarIcon2 />,
    component: () => <CalendarIframe url="https://airtable.com/embed/appUbsPnUAWdyKLEC/shrwa9EFvZh0NgL20?backgroundColor=dark" /> },
];


const ACCOUNT_INNER = [
   { id: 'password', label: 'Password', icon: <LockIcon />, component: ChangePassword }, 
];




const FilterClientPage = () => {
  const [activeTab, setActiveTab] = useState("workflow");
  const { homeAccent } = useUser();

  

  return (
    <div className="fr-tab-page">
      <TabBar
        tabs={TABS}
        activeTab={activeTab}
        onTabChange={setActiveTab}
        homeRoute="/profile"
        homeColor={homeAccent}
      />
      <div className="fr-tab-content">
        {activeTab === 'workflow' && <InnerTabsd tabs={WORKFLOW_INNER} defaultId="clientsticket"/>}
        {activeTab === 'update' && <InnerTabsd tabs={UPDATE_INNER} />}
        {activeTab === 'calendar' && <InnerTabsd tabs={CALENDAR_INNER} />}
        {activeTab === 'clientaccount' && <InnerTabsd tabs={ACCOUNT_INNER} />}
        
        
      </div>
    </div>
  );
};



export default FilterClientPage;